<template>
  <VList
    dense
    shaped
  >
    <div
      v-for="group in list"
      :key="group.title + Date.now()"
    >
      <div
        v-if="(group.show??true) && appAllowAccess(group.authenticated, group.roles, group.permissions) && (group.debug ? isAppDebugMode : true)"
        v-debug="group.debug ? isAppDebugMode : false"
      >
        <VDivider v-if="group.divider" />

        <VSubheader v-if="group.title">
          <div class="text-truncate text-uppercase">
            {{ group.title }}
          </div>
        </VSubheader>

        <div
          v-for="item in group.items"
          :key="item.title + Date.now()"
        >
          <NavItemGroup
            v-if="item.child"
            v-bind="item"
          />
          <NavItem
            v-else
            v-bind="item"
          />
        </div>
      </div>
    </div>
  </VList>
</template>

<script>
import NavItem from '@/components/layouts/Sidebar/NavItem.vue'
import NavItemGroup from '@/components/layouts/Sidebar/NavItemGroup.vue'

export default {
  components: {
    NavItem,
    NavItemGroup
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  }
}
</script>
